import templates from './templates';

export default function* (){
    yield* [...templates];
}